// extracted by mini-css-extract-plugin
export default {"examplePage":"ExamplePage_examplePage__O6CRE"};